// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3adzJ","content":"styles_content__Crlzh","checkbox":"styles_checkbox__1tIY6","checkboxLabel":"styles_checkboxLabel__2mxGk"};